import { RaffleV2, RaffleV2Type } from 'jigsaw';
import { HStack, Text, VStack } from 'ui_2';
import eth_logo from '@assets/eth_logo.png';
import { useMemo } from 'react';

type Props = {
  giveaway: RaffleV2;
};

export const GiveawayRowSmall = ({ giveaway }: Props) => {
  const img = useMemo(() => {
    switch (giveaway.type) {
      case RaffleV2Type.eth:
        return eth_logo;
      case RaffleV2Type.product:
        return (
          giveaway.productSku.smallImageURL ??
          giveaway.productSku.service.smallLogoImageURL
        );
      case RaffleV2Type.aleo:
        return giveaway.sponsor.logoURL;
    }
  }, [JSON.stringify(giveaway)]);

  return (
    <HStack className='w-full max-w-[640px] items-center gap-2 rounded-[10px] bg-white px-3 py-2 shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)]'>
      {img && (
        <img
          src={img}
          className='h-16 w-16 rounded-[10px] border border-gray-100'
        />
      )}
      <VStack>
        <Text font='medium-xs'>
          {giveaway.winnerCount}{' '}
          {giveaway.winnerCount > 1 ? 'winners receive' : 'winner receives'}
        </Text>
        <Text
          font={
            giveaway.prizeDescription.length > 15 ? 'medium-md' : 'medium-lg'
          }
        >
          {giveaway.prizeDescription}
        </Text>
      </VStack>
    </HStack>
  );
};
